(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[625],{

/***/ "keSf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Trident4", function() { return Trident4; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Trident4 = function Trident4(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 333.3"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M500 269.9l-38.1-38.5-38.1 38.5 38.1 38.8 38.1-38.8zm-44.8-260c-2.3-8.2-20.4 3.7-59.6 39.1 15.6 17.4 23.4 7.5 36.1 2.8 9.9 19.4 13.9 106.3-51.6 132.5C381.7 96.8 382.6 3 382.6 3l-3.8-3c-18 2.4-50 34.5-74.5 61.5 13.5 22.5 30.9 2.2 44.4-3.3 0 3.7-3.2 68.3-1.8 134.1-67.4 5.1-56.5-134-52.6-151.8 1.5-14.3-43.4 17.3-65.8 38.3 6.9 12.9 16.9 10.2 29.3 5.5-4.5 62.5 38.8 119.2 89.3 117.8 1.9 64.4 8.4 126.8 26.8 131.2 2.6.6 4.6-65.2 6-138.3C501.5 156.8 455.2 9.9 455.2 9.9zM206.4 139.3v73.6h60.7v45.2h-60.7v61.2h-58.5v-61.2H.3v-45.2l125-191h63.8l-123.6 191h82.4v-73.6h58.5z"
  }));
};

/***/ })

}]);